import { Step } from "react-joyride";
import { VisibilityStates } from "../../types/VisibilityStates";

export const tourStepsCollectionFinalStep = (
  visibilityStates: VisibilityStates,
): Step[] => {
  const steps: Step[] = [
    {
      target: ".collection-final-step",
      content:
        "Step 3: review the items, add extras if you need them, then save. This is the last step before the collection appears on Your Collections.",
      disableBeacon: true,
    },
    {
      target: ".item-preview",
      content:
        "These are the items in the collection so far. You can keep generating or adding until the set looks right.",
      ...(visibilityStates.isItemPreviewVisible ? { isOpen: true } : {}),
    },
    {
      target: ".math-problem-section",
      content:
        "For math collections, pick the numbers and operator, then add the problem to the list.",
      ...(visibilityStates.isMathProblemVisible ? { isOpen: true } : {}),
    },
    {
      target: ".dot-button",
      content: "Use this to add another number-sense or dot item.",
      ...(visibilityStates.isDotButtonVisible ? { isOpen: true } : {}),
    },
    {
      target: ".image-upload-section",
      content:
        "Upload an image if this collection uses pictures instead of plain text.",
      ...(visibilityStates.isImageUploadVisible ? { isOpen: true } : {}),
    },
    {
      target: ".save-collection-button",
      content:
        "Save stores the collection to your account. You can start a session from Your Collections after that.",
      ...(visibilityStates.isSaveButtonVisible ? { isOpen: true } : {}),
    },
  ];

  return steps.filter((step) => {
    if (step.target === ".save-collection-button")
      return visibilityStates.isSaveButtonVisible;
    if (step.target === ".item-preview")
      return visibilityStates.isItemPreviewVisible;
    if (step.target === ".math-problem-section")
      return visibilityStates.isMathProblemVisible;
    if (step.target === ".dot-button")
      return visibilityStates.isDotButtonVisible;
    if (step.target === ".image-upload-section")
      return visibilityStates.isImageUploadVisible;
    return true;
  });
};
